var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.links.length > 0)?_c('div',{staticClass:"nav-menu"},[_c('nav',[_c('ul',_vm._l((_vm.links),function(ref){
var path = ref.path;
var name = ref.name;
var target = ref.target;
var icon = ref.icon;
var color = ref.color;
return _c('li',{key:path},[(path.startsWith('http'))?[_c('a',{class:color || null,attrs:{"href":path,"target":target}},[_c('v-icon',{staticClass:"icon",attrs:{"name":icon || 'box',"color":"darker-gray"}}),_vm._v("\n            "+_vm._s(name)+"\n          ")],1)]:(path)?_c('router-link',{class:color || null,attrs:{"to":path}},[_c('v-icon',{staticClass:"icon",attrs:{"name":icon || 'box',"color":"darker-gray"}}),_vm._v("\n          "+_vm._s(name)+"\n        ")],1):_vm._e()],2)}),0)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }